import { ReactNode, useCallback } from 'react';
import {
    StyledItemContainer,
    StyledInput,
    LabelContainer,
} from './styled';

interface PhoneListInputItemProps {
    label?: ReactNode;
    value: string;
    isSelected?: boolean;
    error?: string;
    onChange?: (value: string | null) => void;
}

const PhoneInputItem = (props: PhoneListInputItemProps) => {
    const {
        label,
        value,
        error,
        isSelected = false,
        onChange = () => {},
    } = props;

    const handleSelect = useCallback(() => {
        if (isSelected) {
            return onChange(null);
        }
        return onChange(value);
    }, [isSelected, onChange, value]);

    return (
        <StyledItemContainer>
            <StyledInput
                type="radio"
                checked={isSelected}
                tabIndex="-1"
                hideLabel
                error={error}
                onChange={handleSelect}
            />
            <LabelContainer>
                {label}
            </LabelContainer>
        </StyledItemContainer>
    );
};

export default PhoneInputItem;
